<template>
  <div>
<div class="row">
                <div class="notification_box question_details">
                  <div class="row padding_rl20 class_question" v-if="debug === true">
                    <div class="col-md-5 col-xs-5">Classification Question</div>
                    <div class="col-md-3 col-xs-3">Response</div>
                    <div class="col-md-1 col-xs-1">Level</div>
                    <div class="col-md-2 col-xs-2">Interim Class/Class</div>
                    <div class="col-md-1 col-xs-1">Rule Ref</div>
                  </div>
                  <div class="row padding_rl20 class_question" v-else>
                    <div class="col-md-8 col-xs-8">Classification Question</div>
                    <div class="col-md-4 col-xs-4">Response</div>
                  </div>
                  <div class="hr-thin-summary"></div>
                  <div
                    v-for="(data,index) in workflowDataArray"
                    v-bind:key="index"
                    class="row padding_rl20"
                    style="padding-top:10px;padding-bottom:5px;"
                  >
                    <div class="class_question_summary" v-if="debug == true">
                      <div class="col-md-5 col-xs-5 class_question_summary">
                        <a href="javascript:void(0);" class="service" @click="navigateBack(data.step-1)">
                          <span v-html="data.question"></span>
                        </a>
                        <i class="fas fa-redo"></i>
                        <base-tooltip :content="`Click to jump to Step -> ${data.step}`" v-if="info == true">
                          <!-- <div class="tooltip_content tooltip-width" slot="content">
                            <span
                              style="overflow-wrap: normal;"
                            >Click to jump to Step -> {{data.step}}</span>
                          </div> -->
                          <span class="email_tooltip">
                            <i class="fa fa-question-circle"></i>
                          </span>
                        </base-tooltip>
                      </div>
                      <div class="col-md-3 col-xs-3"><span v-html="data.classNote"/></div>
                      <div class="col-md-1 col-xs-1">{{data.level}}</div>
                      <div class="col-md-2 col-xs-2">
                        <span v-html="data.interimClass"></span>
                        <span v-if="!data.classCode">/<span v-html="data.classCode"></span></span>
                      </div>
                      <div class="col-md-1 col-xs-1">{{data.ruleRef}}</div>
                    </div>
                    <div class="class_question_summary" v-else>
                      <div class="col-md-8 col-xs-8">
                        <a href="javascript:void(0);" class="service" @click="navigateBack(data.step-1)">
                          <span v-html="data.question"></span>
                        </a>
                        <base-tooltip :content="`Click to Go Back to Step -> ${data.step}`" v-if="info == true">
                          <!-- <div class="tooltip_content tooltip-width" slot="content">
                            <span
                              style="overflow-wrap: normal;"
                            >Click to Go Back to Step -> {{data.step}}</span>
                          </div> -->
                          <span class="email_tooltip">
                            <i class="fa fa-question-circle"></i>
                            <i class="fa fa-undo" aria-hidden="true"></i>
                          </span>
                        </base-tooltip>
                      </div>
                      <div class="col-md-4 col-xs-4">
                        <span v-html="data.answer"></span>
                      </div>
                    </div>
                     <div class="row padding_rl20 hr-thin-separator"></div>
                  </div>
                </div>
              </div>
  </div>
</template>
<script>
export default {
  props: [
    'prodClassCriteria',
    'debug',
    'info',
    'compositeArrayWrapper',
  ],
  data() {
    return {
      activeNames: [''],
    };
  },
  computed: {
    /* classData() {
      const classData = {
        code: this.prodClassCriteria.compositeArrayWrapper.classCode,
        flag: this.prodClassCriteria.compositeArrayWrapper.classFoundFlag,
      };
      return classData;
    },
    sortedLevelArray() {
      const sortedLevelAray = this.prodClassCriteria.levelArray;
      return sortedLevelAray;
    },
    arrayLengths() {
      const arrLengthHolder = {
        srch_cri_arr_len: this.prodClassCriteria.searchCriteriaArray
          ? this.prodClassCriteria.searchCriteriaArray.length
          : null,
        wf_resp_arr: this.prodClassCriteria.workflowResponseCache
          ? this.prodClassCriteria.workflowResponseCache.length
          : null,
      };
      return arrLengthHolder;
    }, */
    workflowDataArray() {
      const workflowDataArray = [];
      let indx = 0;
      const wfResponseCache = this.prodClassCriteria.workflowResponseCache;
      if (wfResponseCache && wfResponseCache.length > 0) {
        wfResponseCache.forEach((srchCritArrElement) => {
          if (srchCritArrElement) {
            const currTitleDataAndChildOptions = srchCritArrElement.response_data;
            const { choices } = srchCritArrElement;
            let answer = '';
            let levelComputed = '';
            let ruleRef = '';
            let intClass = '';
            if (Array.isArray(choices)) {
              choices.forEach((e) => {
                const valArray = e.split('|');
                answer += `${valArray[0]},`;
                levelComputed += `${valArray[2]},`;
                ruleRef += !valArray[6] ? `${valArray[6]},` : '';
                intClass += !valArray[5] ? `${valArray[5]},` : '';
              });
            } else {
              const valArray = choices.split('|');
              [answer] = valArray;
              levelComputed += valArray[2];
              [, , , , , , ruleRef] = valArray;
              [, , , , , intClass] = valArray;
            }

            const workflowDataIns = {
              step: (indx += 1),
              question: currTitleDataAndChildOptions.vital_characteristic,
              answer,
              level: levelComputed,
              interimClass: intClass,
              ruleRef,
            };
            workflowDataArray.push(workflowDataIns);
          }
        });
      }
      return workflowDataArray;
    },
  },
  methods: {
    /**
     * Backward navigation
     */
    navigateBack(stepToJumpTo) {
      const noOfElementsToPop = this.prodClassCriteria.workflowResponseCache.length - stepToJumpTo;
      if (noOfElementsToPop === 1) {
        this.$parent.setOptionInfo();
      }
      for (let idx = 1; idx < noOfElementsToPop; idx += 1) {
        this.prodClassCriteria.workflowResponseCache.pop();
        this.prodClassCriteria.levelArray.pop();
        this.$parent.currLevel.pop();
        // Delete elements from the back in the map that is keeping selected Queries.
        const keys = [...this.$parent.searchCriteriaMap.keys()];
        const lastKey = keys[keys.length - 1];
        this.$parent.searchCriteriaMap.delete(lastKey);
        this.$parent.levelArrayMap.delete(lastKey);
        this.prodClassCriteria.interimClassMap.delete(lastKey);
      }

      this.prodClassCriteria.compositeArrayWrapper.dataArray = [
        this.prodClassCriteria.workflowResponseCache[
          this.prodClassCriteria.workflowResponseCache.length - 1
        ].response_data,
      ];
      const choicesObj = this.prodClassCriteria.workflowResponseCache[
        this.prodClassCriteria.workflowResponseCache.length - 1
      ].choices;
      // EU MDD and EU MDR has one special question. (Multi Select).
      // If user jumps back to that question then we need to prepare data accordingly
      if (Array.isArray(choicesObj)) {
        this.prodClassCriteria.selectedChoices = [];
        this.prodClassCriteria.selectedChoices = choicesObj;
        this.multi_select = true;
      } else {
        this.prodClassCriteria.selectedOptions = choicesObj;
      }
      this.prodClassCriteria.current_slide_number = 1; // Re-set current slide no. As it was advanced to 2 on summary page.
      if (noOfElementsToPop !== 1) {
        this.$parent.resetClassInfo();
      }
    },
    /* handleChange() {}, */
  },
  /* mounted() {}, */
};
</script>
<style scoped>
.notification_box {
  min-height: 110px;
  position: relative;
  display: block;
  background: #ffffff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-left: 20px;
  margin: 15px 20px 10px 20px;
  padding: 14px 10px 10px 2px;
}
.question_details {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.class_question {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #00518a;
}
.padding_rl20 {
  padding-right: 20px;
  padding-left: 20px;
}
.class_question_summary {
  font-size: 15px;
  line-height: 23px;
}
</style>
